import { Nullable } from '../../../core/type'

export interface VendorLabelInput {
  id?: Nullable<number>
  company?: Nullable<string>
  designer?: Nullable<string>
  firstName?: Nullable<string>
  lastName?: Nullable<string>
  contactId?: Nullable<string>
}


const vendorName = (vendor: VendorLabelInput): string | undefined => {
  const company = vendor.company?.trim()
  const designer = vendor.designer?.trim()
  const fullName = [vendor.firstName, vendor.lastName]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(' ')

  return company || designer || fullName || undefined
}

export const vendorOptionLabel = (vendor: VendorLabelInput): string => {
  const name = vendorName(vendor)
  const contactId = vendor.contactId?.trim()

  if (name) {
    return contactId ? `${name} - ${contactId}` : name
  }

  if (contactId && contactId !== '-') {
    return contactId
  }

  return vendor.id != null ? `#${vendor.id}` : contactId || '—'
}

export const vendorSortKey = (vendor: VendorLabelInput): string => {
  const name = vendorName(vendor)
  if (name) {
    return `0${name.toLowerCase()}`
  }

  const contactId = vendor.contactId?.trim()
  if (contactId && contactId !== '-') {
    return `0${contactId.toLowerCase()}`
  }

  return `1${vendorOptionLabel(vendor).toLowerCase()}`
}
